module.exports = __webpack_public_path__ + "static/rfa-adi@2x-1-1cc3939ce7d3bd5259f2e63124d52e97.png";